module.exports = __webpack_public_path__ + "img/image_service_8.ffc0ba6c.png";